<template>
  <v-card class="fill-height text-left d-flex flex-column dsfr" outlined>
    <v-card-item>
      <v-card-title class="font-weight-bold">
        {{ study.title }}
      </v-card-title>
      <v-card-subtitle>
        {{ study.canteen.name }}
      </v-card-subtitle>
      <v-card-subtitle class="text-muted">
        {{ study.canteenName }}
      </v-card-subtitle>
    </v-card-item>

    <v-card-text class="py-2">
      <p class="mb-1">
        <strong>Durée :</strong>
        {{ study.study.durationInDay }} jours
      </p>
      <p class="mb-1" v-if="loggedUser.job == 'CONSUMER'">
        <strong>Description :</strong>
        {{ study.study.descriptionConsumer }}
      </p>
      <p class="mb-1" v-else>
        <strong>Description :</strong>
        {{ study.study.descriptionGeneral }}
      </p>
    </v-card-text>

    <v-spacer></v-spacer>
    <v-card-actions class="px-4 py-4">
      <v-btn text class="rounded" :to="`/actions/${this.study.id}/details/`">
        Voir les instructions
        <v-icon small class="menu-arrow ml-2">
          $arrow-right-line
        </v-icon>
      </v-btn>
    </v-card-actions>

    <div v-if="loggedUser.job == 'COOK' || loggedUser.job == 'NUTRITIONIST' || loggedUser.job == 'RESEARCHER'">
      <v-card-actions class="px-4 py-4" v-if="study.status == 'CREATED'">
        <v-spacer></v-spacer>
        <v-btn color="success" variant="tonal" class="rounded" @click="startAction()">
          Démarrer l'action
        </v-btn>
      </v-card-actions>

      <v-card-actions class="px-4 py-4" v-if="study.status == 'ONGOING'">
        <v-spacer></v-spacer>
        <v-btn color="warning" variant="tonal" class="rounded" disabled>
          Action en cours
        </v-btn>
      </v-card-actions>

      <v-card-actions class="px-4 py-4" v-if="study.status == 'ENDED'">
        <v-spacer></v-spacer>
        <v-btn color="warning" variant="tonal" class="rounded" disabled>
          Terminée
        </v-btn>
      </v-card-actions>
    </div>

    <div v-else>
      <v-card-actions class="px-4 py-4" v-if="this.study.participants.includes(loggedUser.id)">
        <v-spacer></v-spacer>
        <v-btn color="warning" variant="tonal" class="rounded" disabled>
          Vous participez
        </v-btn>
      </v-card-actions>

      <v-card-actions class="px-4 py-4" v-else>
        <v-spacer></v-spacer>
        <v-btn color="success" variant="tonal" class="rounded" @click="engageAction()">
          Participer
        </v-btn>
      </v-card-actions>
    </div>
  </v-card>
</template>

<script>
export default {
  props: {
    study: {
      type: Object,
      required: true,
    },
  },
  methods: {
    async startAction() {
      const studyId = this.study.id // Récupère l'ID de l'étude
      await this.$store
        .dispatch("startAction", { studyId })
        .then(() => {
          this.study.status = "ONGOING"
        })
        .catch((e) => this.$store.dispatch("notifyServerError", e))
    },
    async engageAction() {
      const studyId = this.study.id // Récupère l'ID de l'étude
      await this.$store
        .dispatch("engageInAction", { studyId })
        .then(() => this.study.participants.push(this.loggedUser.id))
        .catch((e) => this.$store.dispatch("notifyServerError", e))
    },
  },
  computed: {
    loggedUser() {
      return this.$store.state.loggedUser
    },
  },
}
</script>

<style scoped>
.study-card {
  max-width: 400px;
  border-radius: 8px;
}

.v-card-title {
  font-size: 1.25rem;
  color: #1e88e5; /* Couleur principale */
}

.v-card-subtitle {
  font-size: 0.9rem;
  color: #757575; /* Couleur secondaire (gris) */
}

.v-card-text p {
  margin: 0;
  color: #424242; /* Texte principal */
}

.v-card-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.v-btn {
  background-color: #e3f2fd; /* Fond bleu clair */
}
.v-btn:hover {
  background-color: #bbdefb; /* Fond bleu plus sombre au hover */
}
</style>
